export default "__VITE_ASSET__DarXAscD__"